module.exports = __webpack_public_path__ + "img/main_menu_hover_4.61708de5.png";